// Settings.jsx
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateProfileApi, changePasswordApi } from '../api/authApi';

export default function Settings() {
  const { user, updateUser } = useAuth();
  const [profile, setProfile] = useState({ name: user?.name||'', phone: user?.phone||'', department: user?.department||'' });
  const [pwForm, setPwForm]   = useState({ currentPassword:'', newPassword:'', confirmPassword:'' });
  const [profileMsg, setProfileMsg] = useState('');
  const [pwMsg, setPwMsg]           = useState('');
  const [profileErr, setProfileErr] = useState('');
  const [pwErr, setPwErr]           = useState('');
  const [saving, setSaving]         = useState(false);
  const [savingPw, setSavingPw]     = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault(); setProfileMsg(''); setProfileErr(''); setSaving(true);
    try { const r = await updateProfileApi(profile); updateUser(r.data.data.user); setProfileMsg('Profile updated successfully.'); }
    catch(err) { setProfileErr(err.response?.data?.message || 'Failed.'); }
    finally { setSaving(false); }
  };

  const savePw = async (e) => {
    e.preventDefault(); setPwMsg(''); setPwErr('');
    if (pwForm.newPassword !== pwForm.confirmPassword) { setPwErr("Passwords don't match."); return; }
    setSavingPw(true);
    try { await changePasswordApi({ currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword }); setPwMsg('Password changed.'); setPwForm({ currentPassword:'', newPassword:'', confirmPassword:'' }); }
    catch(err) { setPwErr(err.response?.data?.message || 'Failed.'); }
    finally { setSavingPw(false); }
  };

  const initials = user?.name?.split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase();

  return (
    <div className="slide-up" style={{ maxWidth:640 }}>
      <div className="page-header"><div className="page-header-left"><h1>Settings</h1><p>Manage your account preferences</p></div></div>

      <div className="card" style={{ marginBottom:'1.5rem' }}>
        <div className="card-title">Profile Information</div>
        <div style={{ display:'flex', alignItems:'center', gap:'1rem', marginBottom:'1.5rem' }}>
          <div style={{ width:56, height:56, borderRadius:'50%', background:'var(--earth)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.2rem', fontWeight:500, color:'var(--charcoal)' }}>{initials}</div>
          <div>
            <p style={{ fontWeight:500, fontSize:'1rem' }}>{user?.name}</p>
            <p style={{ fontSize:'0.82rem', color:'var(--muted)' }}>{user?.email}</p>
            <span className={`badge badge-${user?.role}`}>{user?.role}</span>
          </div>
        </div>
        {profileMsg && <div className="alert alert-success">{profileMsg}</div>}
        {profileErr && <div className="alert alert-error">{profileErr}</div>}
        <form onSubmit={saveProfile}>
          <div className="form-group"><label className="form-label">Full Name</label><input className="form-input" value={profile.name} onChange={e => setProfile({...profile, name:e.target.value})} required /></div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={profile.phone} onChange={e => setProfile({...profile, phone:e.target.value})} /></div>
            <div className="form-group"><label className="form-label">Department</label><input className="form-input" value={profile.department} onChange={e => setProfile({...profile, department:e.target.value})} /></div>
          </div>
          <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Update Profile'}</button>
        </form>
      </div>

      <div className="card">
        <div className="card-title">Change Password</div>
        {pwMsg && <div className="alert alert-success">{pwMsg}</div>}
        {pwErr && <div className="alert alert-error">{pwErr}</div>}
        <form onSubmit={savePw}>
          <div className="form-group"><label className="form-label">Current Password</label><input className="form-input" type="password" value={pwForm.currentPassword} onChange={e => setPwForm({...pwForm, currentPassword:e.target.value})} required /></div>
          <div className="form-group"><label className="form-label">New Password</label><input className="form-input" type="password" value={pwForm.newPassword} onChange={e => setPwForm({...pwForm, newPassword:e.target.value})} required minLength={6} /></div>
          <div className="form-group"><label className="form-label">Confirm New Password</label><input className="form-input" type="password" value={pwForm.confirmPassword} onChange={e => setPwForm({...pwForm, confirmPassword:e.target.value})} required /></div>
          <button className="btn btn-primary" type="submit" disabled={savingPw}>{savingPw ? 'Changing…' : 'Change Password'}</button>
        </form>
      </div>
    </div>
  );
}